import axios from 'axios';
import { REST_HOSTNAME } from '../Config';
import { DialogPrompt } from './DialogPromptApi';

const axiosInstance = axios.create({
    baseURL: REST_HOSTNAME
});

// Add request interceptor
axiosInstance.interceptors.request.use(
    function (config) {
        const jwt = localStorage.getItem('jwt');
        if (jwt) {
            config.headers['x-access-token'] = jwt; // Add JWT to the headers
        }
        return config;
    },
    function (error) {
        return Promise.reject(error);
    }
);

export interface IUserDialogPrompt {
    id: number;
    user_id: number;
    dialog_prompt_id: number;
    is_completed: boolean;
    incorrect_answer_count: number;
    correct_answer_count: number;
    speaking_attempt_count: number;
    best_speaking_score: number;
    created_at: Date,
    updated_at: Date,
}

export type UserDialogPromptUserSummary = {
    course_id: number;
    lesson_id: number;
    dialog_id: number;
    dialog_prompt_count: number;
    user_dialog_prompt_count: number;
};

// export type UserDialogPromptCourseExerciseSummary = {
//     course_id: number;
//     lesson_id: number;
//     dialog_id: number;
//     dialog_prompt_id: number;
//     user_count: number;
//     incorrect_answer_count: number;
//     correct_answer_count: number;
//     speaking_attempt_count: number;
//     mean_best_speaking_score: number;
// };

export interface UserDialogPromptReviewResponse {
    today_dialog_prompt_list: DialogPrompt[];
    yesterday_dialog_prompt_list: DialogPrompt[];
    last_week_dialog_prompt_list: DialogPrompt[];
    last_month_dialog_prompt_list: DialogPrompt[];
    before_last_month_dialog_prompt_list: DialogPrompt[];
}

export const UserDialogPromptApi = {
    getAll: function (dialogId?: number) {
        return axiosInstance.request<IUserDialogPrompt[]>({
            method: "GET",
            url: `/user_dialog_prompt`,
            params: dialogId !== undefined ? { dialog_id: dialogId } : undefined,
            transformResponse: [(data) => {
                const raw = typeof data === 'string' ? JSON.parse(data) : data;
                return (raw as any[]).map(item => ({
                    ...item,
                    created_at: item.created_at == null ? item.created_at : new Date(item.created_at),
                    updated_at: item.updated_at == null ? item.updated_at : new Date(item.updated_at),
                }));
            }],
        });
    },
    getById: function (userDialogPromptId: number) {
        return axiosInstance.request<IUserDialogPrompt>({
            method: "GET",
            url: `/user_dialog_prompt/${userDialogPromptId}`,
            transformResponse: [(data) => {
                const item = typeof data === 'string' ? JSON.parse(data) : data;
                return {
                    ...item,
                    created_at: item.created_at == null ? item.created_at : new Date(item.created_at),
                    updated_at: item.updated_at == null ? item.updated_at : new Date(item.updated_at),
                };
            }],
        });
    },
    completeDialogPrompt: function (dialogPromptId: number, userDialogPromptReviewResponse?: UserDialogPromptReviewResponse) {
        return axiosInstance.request<UserDialogPromptUserSummary[]>({
            method: "PUT",
            url: `/user_dialog_prompt/${dialogPromptId}/complete`,
            ...(userDialogPromptReviewResponse
                ? {
                    data: {
                        today_dialog_prompt_list:
                            userDialogPromptReviewResponse.today_dialog_prompt_list,
                        yesterday_dialog_prompt_list:
                            userDialogPromptReviewResponse.yesterday_dialog_prompt_list,
                        last_week_dialog_prompt_list:
                            userDialogPromptReviewResponse.last_week_dialog_prompt_list,
                        last_month_dialog_prompt_list:
                            userDialogPromptReviewResponse.last_month_dialog_prompt_list,
                        before_last_month_dialog_prompt_list:
                            userDialogPromptReviewResponse.before_last_month_dialog_prompt_list,
                    },
                }
                : {}),
        });
    },
    addIncorrectAnswer: function (dialogPromptId: number) {
        return axiosInstance.request<IUserDialogPrompt>({
            method: "POST",
            url: `/user_dialog_prompt/${dialogPromptId}/incorrect_answer`
        });
    },
    addCorrectAnswer: function (dialogPromptId: number) {
        return axiosInstance.request<IUserDialogPrompt>({
            method: "POST",
            url: `/user_dialog_prompt/${dialogPromptId}/correct_answer`
        });
    },
    addSpeakingAttempt: function (dialogPromptId: number, speakingScore: number) {
        return axiosInstance.request<IUserDialogPrompt>({
            method: "POST",
            url: `/user_dialog_prompt/${dialogPromptId}/speaking_attempt`,
            data: { 'speaking_score': speakingScore }
        });
    },
    getCurrentUserSummary: function () {
        return axiosInstance.request<UserDialogPromptUserSummary[]>({
            method: "GET",
            url: `/user_dialog_prompt/current_user_summary`
        });
    },
    // getCourseExerciseSummary: function (courseId: number) {
    //     return axiosInstance.request<UserDialogPromptCourseExerciseSummary[]>({
    //         method: "GET",
    //         url: `/user_dialog_prompt/course_exercise_summary/${courseId}`
    //     });
    // },
    // getCourseUserSummary: function (courseId: number) {
    //     return axiosInstance.request<UserDialogPromptCourseUserSummary[]>({
    //         method: "GET",
    //         url: `/user_dialog_prompt/course_student_summary/${courseId}`
    //     });
    // },
    getNextDialogPrompt: function () {
        return axiosInstance.request<DialogPrompt>({
            method: "GET",
            url: `/user_dialog_prompt/next_dialog_prompt`
        });
    },
    getUserDialogPromptReview: function () {
        return axiosInstance.request<UserDialogPromptReviewResponse>({
            method: "GET",
            url: `/user_dialog_prompt/review`
        });
    }

}
